<div class="accordion accordion-flush">

  <div class="accordion-item">

    <label class="accordion-header">
      <button class="accordion-button" [class.collapsed]="collapsed()" type="button" aria-expanded="false"
        (click)="toggle()">
        {{config.label | translate }}
        @if(valuesCounter()){
        <span class="badge text-bg-primary">
          {{'filter.selected'|translate:{n: valuesCounter()} }}
        </span>
        }
      </button>
    </label>

    <div #accordion class="accordion-collapse collapse">

      <div class="accordion-body">

        @for(opt of config.options; let i = $index; track opt.idTerm){
        <div class="form-check">
          <input class="form-check-input" type="checkbox" [attr.id]="getOptionId(i)" [checked]="isChecked(opt.idTerm)"
            (change)="handleChange(opt.idTerm)">
          <label class="form-check-label" [attr.for]="getOptionId(i)">
            {{opt.label}}
          </label>
        </div>
        }

        @if(showDeselectAllOption){
        <div class="form-check">
          <input class="form-check-input hidden" type="checkbox" (change)="handleDeselect()"
            [attr.id]="'deselect-'+config.field">
          <label class="form-check-label" [attr.for]="'deselect-'+config.field">
            {{'filter.deselect'|translate}}
          </label>
        </div>
        }

      </div>

    </div>

  </div>

</div>
